<template>
    <template v-if="mode === 'table'">
        {{v}}
    </template>
    <template v-else-if="mode === 'edit'">

                <v-text-field :label=column.title variant="outlined" type="Number" v-model="v"  @input="handleInput"></v-text-field>
       
    </template>
    <template v-else>
        {{v}}
    </template>
    
</template>

<script>
export default {
    name: 'number-widget',
    props:['mode','column', 'modelValue'],
    emits: ['update:modelValue'],
    data(){ 
        return {
            v: this.modelValue,
        }
    },   
    methods:{
        handleInput (e) {   
        let choosedvalue = '';
        if (e.target.value !== ''){
        choosedvalue = e.target.value;
        }  
        else{
        choosedvalue = null;
        }
        this.$emit('update:modelValue', choosedvalue);
        this.v = choosedvalue;
        },
    },

    watch: {
    modelValue() {
        this.v = this.modelValue;
    }
    
},
}
</script>
